import React, { FC } from "react";
import { iViewBoxProps, PointType } from "./SummaryChart.helpers";
import cn from "classnames";

interface iDot {
    x: number;
    y: number;
    label: string;
    type: PointType;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
}


const ChartDots: FC<{
    data: iDot[];
    viewport: iViewBoxProps;
}> = (
    {
        data,
        viewport,
    }
) => {
    return (
        <div
            className="FoodSummaryChart__dots FoodSummary__blur"
            style={{
                top: viewport.padding.top,
                left: viewport.padding.left,
                width: viewport.width,
                height: viewport.height,
            }}
            data-testid={`textChartDots`}
        >
            {data.map((dot, dotIndex) => (
                <div
                    key={dotIndex}
                    className="FoodSummaryChartDot"
                    style={{
                        transform: `translate(${dot.x}px, ${dot.y}px)`
                    }}
                >
                    <div
                        onMouseEnter={dot.onMouseEnter}
                        onMouseLeave={dot.onMouseLeave}
                        className={cn('FoodSummaryChartDot__inner', `is-${dot.type}`)}
                        data-testid={`textChartDot${dotIndex}`}
                    >
                        {dot.label}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ChartDots;